import React from 'react';
import "./styles.css";
import EditDealership from '../EditDealership';

const AcceptTermsAndConditions = () => {
  return (
    <div className="acpt-tnc">
      <div className="acpt-tnc-form-cnt">
        <EditDealership tnc />
      </div>
    </div>
  )
}

export default AcceptTermsAndConditions;